import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {inject, onMounted, ref} from 'vue'
import {Billing, PaymentType} from "@/components/blocks/Types";
import {buildMoment} from "@/components/blocks/Functions";
import {AxiosStatic} from "axios";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {useUserStore} from "@/stores/UserStore";
import {formatDate} from "../../services/FormatService";

// Define store

export default /*#__PURE__*/_defineComponent({
  __name: 'ListPaymentsTable',
  setup(__props, { expose }) {


const userStore = useUserStore()

// Define inject
const axios = inject<AxiosStatic>('axios')

// Define refs
const items = ref<PaymentType[]>([])
const loading = ref<boolean>(true)
const dt = ref(null);
const pageIndex = ref<number>(0)
const pageSize = ref<number>(25)
const totalRecords = ref<number>(0)

// Define lifecycle hooks
onMounted(() => {
  loadData()
})
// Define function
function loadData() {
  loading.value = true
  axios?.get('/payment/list?companyId=' + userStore.userDetail.company.id)
      .then((response) => {
        if (response.status === 200) {
          items.value = response.data
        }
        totalRecords.value = response.data.length
        loading.value = false
      }).catch(error => {
    console.error('Can not load payments', error)
    loading.value = false
  })
}


// Define expose
expose({loadData})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataTable), {
    page: pageIndex.value+1,
    ref_key: "dt",
    ref: dt,
    dataKey: "id",
    value: items.value,
    paginator: true,
    rows: pageSize.value,
    rowHover: true,
    totalRecords: totalRecords.value,
    loading: loading.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        field: "paymentDate",
        header: "Datum"
      }, {
        body: _withCtx(({data}) => [
          _createTextVNode(_toDisplayString(_unref(formatDate)(data.paymentDate)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "payment",
        header: "Částka"
      }),
      _createVNode(_unref(Column), {
        field: "note",
        header: "Poznámka"
      })
    ]),
    _: 1
  }, 8, ["page", "value", "rows", "totalRecords", "loading"]))
}
}

})